import React from 'react';
import {AutoSaveDropdownBreakField} from '../Component Sets/MultiPlatformComponents';
import {isNoU} from "utils/DBUtils";

/**
 *  We need a custom component to gather the options from a proxy to populate
 *  the dropdown to select a result for various answers
 */
const AnswerResultDropdown = (props) => {
  let results = props.formProxy.grandParentCurrentResource.results;
  let options = [];
  if ( !isNoU(results) ) {
    for(let i=0;i<results.length;i++) {
      options.push({
        text: results[i].title ? results[i].title : "Result " + (i+1),
        value: results[i].id
      });
    }
  }

  return <AutoSaveDropdownBreakField {...props} options={options}/>
};

AnswerResultDropdown.propTypes = {};

export default AnswerResultDropdown;



// WEBPACK FOOTER //
// ./public/components/forms/CustomFields/AnswerResultDropdown.jsx